<template>
    <BaseSection>
        <template #title>
            <h2 v-if="title">{{ title }}</h2>
            <h2 v-else>Sections</h2>
        </template>

        <template
            v-if="subtitle"
            #subtitle
        >
            {{ subtitle }}
        </template>

        <BaseBanners
            v-if="sections && sections.length"
            :items="sections"
        />
    </BaseSection>
</template>

<script setup>
defineProps({
    title: {
        type: String,
        default: 'Sections',
        required: false,
    },
    subtitle: {
        type: String,
        default: null,
        required: false,
    },
    sections: {
        type: Array,
        default: null,
        required: false,
    },
});
</script>
